<template>
    <div>
        <div class="bg-light header">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="logo col-5 mt-2 mb-2">
                        <img alt="AirPro Auggie Management" src="@/shared/assets/logo-small.png" />
                    </div>
                    <div class="title col-3 mt-2 mb-2">Auggie Calibration</div>
                    <div class="device col-4 mt-2 mb-2">{{ deviceName() }}</div>
                </div>
            </div>
        </div>
        <battery-panel v-show="batteryShown()"
                       :battery-level="batteryLevel()"
                       :charging="charging()" />
        <div class="container environment">
            <div v-if="environmentName" class="row">
                <div class="alert alert-danger">
                    {{ environmentName }}
                </div>
            </div>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .header {
        height: auto;
    }
    .title {
        font-weight: bold;
        text-align: center;
    }
    .device {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: right;
    }
    .environment {
        margin-top: 1rem;
        text-align:center;
        font-size:1.2rem;
        font-weight: bolder;
        .alert {
            margin-bottom:0;
        }
    }
</style>

<script lang="ts">

import { Global } from "@/support/GlobalData";
import Globals from "@/support/Globals";
import { defineComponent } from "vue";

let BatteryShown = true;

export function setBatteryShown(value: boolean): void {
    BatteryShown = value;
}

export function getBatteryShown(): boolean {
    return BatteryShown;
}

export default defineComponent({
    data() {
        return {
            environmentName: Globals.GetEnvironment(),
        };
    },
    methods: {
        deviceName(): string {
            return Global.DeviceName;
        },
        batteryShown(): boolean {
            return BatteryShown && Global.BatteryPercentageFull != null;
        },
        batteryLevel(): number {
            return Global.BatteryPercentageFull || 0;
        },
        charging(): boolean {
            return Global.BatteryExternalPower || false;
        },
        update(): void {
            this.$forceUpdate();
        },
    },
});
</script>
